import React, { useEffect, useState } from "react";
import { ArrowRight, Clock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { PROMO } from "../data/promo";

export default function StickyPriceBar() {
  const [visible, setVisible] = useState(false);
  const [hideOnAcquista, setHideOnAcquista] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
      const acq = document.getElementById("acquista");
      if (acq) {
        const rect = acq.getBoundingClientRect();
        setHideOnAcquista(rect.top < window.innerHeight && rect.bottom > 0);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible || hideOnAcquista) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 px-4 pb-4 md:px-6 md:pb-6 pointer-events-none">
      <div className="max-w-4xl mx-auto pointer-events-auto">
        <div className="rounded-2xl bg-white/95 backdrop-blur-md border border-slate-200 shadow-[0_20px_60px_-15px_rgba(16,42,107,0.35)] p-4 md:p-5 flex items-center gap-3 md:gap-5">
          <div className="hidden sm:flex h-12 w-12 rounded-xl bg-[#f59e0b] text-[#0a1f55] items-center justify-center shrink-0">
            {PROMO.active ? <Sparkles className="h-5 w-5" /> : <Clock className="h-5 w-5" />}
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-[11px] uppercase tracking-wider font-bold text-[#f59e0b]">
              {PROMO.active ? `${PROMO.badge} · ${PROMO.labelOfferta}` : "Posti limitati • Inizia ora"}
            </div>
            <div className="text-[14px] md:text-[15px] font-extrabold text-[#0a1f55] leading-tight">
              Corso Consulente Digitale{" "}
              {PROMO.active ? (
                <>
                  <span className="line-through text-slate-400 font-bold">€ {PROMO.prezzoListinoCorso}</span>{" "}
                  <span className="text-red-600">€ {PROMO.prezzoPromoCorso}</span>
                </>
              ) : (
                <span className="text-[#102a6b]">da € 99</span>
              )}
            </div>
          </div>
          <a href="#acquista" className="shrink-0">
            <Button className="bg-[#102a6b] hover:bg-[#0a1f55] text-white h-11 px-4 md:px-5 font-bold">
              Acquista
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
}
